import { render, staticRenderFns } from "./chat-setting-form.vue?vue&type=template&id=a7316a12&scoped=true&"
import script from "./chat-setting-form.vue?vue&type=script&lang=ts&"
export * from "./chat-setting-form.vue?vue&type=script&lang=ts&"
import style0 from "./chat-setting-form.vue?vue&type=style&index=0&id=a7316a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7316a12",
  null
  
)

export default component.exports